import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  actions: {
    padding: 16,
  },
  currentAddressBackground: {
    marginTop: 16,
    padding: 16,
    width: '100%',
    height: '30%',
    borderRadius: 8,
    backgroundColor: 'rgba(211,211,211, 0.3)',
  },
  buttonActionsContainer: {
    margin: '0.5rem',
    gap: 10,
  },
  dialogContentContainer: {
    marginBottom: 20,
  },
  closeIcon: {
    position: 'absolute',
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
  },
  bold: {
    fontWeight: 700,
  },
  noNumberField: {
    '& > div': {
      [theme.breakpoints.up('sm')]: {
        paddingTop: 20,
      },
    },
  },
}));
